<template>
  <div class="timetable-wrapper">
    <div>
      <div class="bold-text mb-1">Lịch học</div>
      <div class="body-2 grey--text">Thiết lập thông tin về lịch học của lớp</div>
    </div>
    <v-divider class="my-4" />
    <div>
      <div class="bold-text mb-1">Thông tin số buổi học và ngày khai giảng</div>
      <BeginningDateDisplay :beginning-date="beginningDate" @redirect="redirectToClass" />
      <v-divider class="my-4" />
      <div class="bold-text mb-4">Thời gian kết thúc</div>
      <EndDateTimePicker :end-date-time="endDateTime" @update:end-date-time="updateEndDateTime" />
      <v-divider class="my-4" />
      <div class="bold-text body-2">{{ 'Cấu hình lịch học cụ thể' }}</div>
      <ScheduleTypeSelector v-model="scheduleType" @change="onChange" />
      <CourseClassWeekSchedule
        v-show="scheduleType === 'weekly-schedule'"
        :schedules="weeklySchedules"
        @create="() => addMoreSchedule('weekly-schedule')"
        @delete="deleteSchedule"
        class="mt-2"
      />
      <CourseClassFreeSchedule
        v-show="scheduleType === 'free-schedule'"
        :schedules="freeSchedules"
        @create="() => addMoreSchedule('free-schedule')"
        @delete="deleteSchedule"
        @update:schedules="updateFreeSchedules"
        class="mt-2"
      />
    </div>
  </div>
</template>

<script>
import get from 'lodash-es/get'
import uuid from 'uuid'
import moment from 'moment'
import CourseClassWeekSchedule from './CourseClassWeekSchedule.vue'
import CourseClassFreeSchedule from './CourseClassFreeSchedule.vue'
import BeginningDateDisplay from './BeginningDateDisplay.vue'
import EndDateTimePicker from './EndDateTimePicker.vue'
import ScheduleTypeSelector from './ScheduleTypeSelector.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    CourseClassWeekSchedule,
    CourseClassFreeSchedule,
    BeginningDateDisplay,
    EndDateTimePicker,
    ScheduleTypeSelector,
  },
  props: {
    classProp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      get,
      moment,
      scheduleType: 'weekly-schedule',
      schedule: [],
      freeSchedules: [],
      weeklySchedules: [],
      classData: {},
      beginningDate: null,
      endDateTime: null,
    }
  },
  methods: {
    ...mapActions({
      setQuery: 'grade/setQuery',
    }),
    reset() {
      this.schedule = []
      this.freeSchedules = []
      this.weeklySchedules = []
      this.classData = {}
      this.scheduleType = 'weekly-schedule'
      this.endDateTime = null
    },
    onChange(state) {
      this.schedule = []
      this.scheduleType = state
    },
    addMoreSchedule(type) {
      let payload = {
        id: 'new_' + uuid.v4(),
        startTime: '13:00',
        endTime: '14:00',
        type,
        classroom: '',
      }
      if (type === 'weekly-schedule') payload['day'] = 'monday'
      if (type === 'free-schedule') payload['date'] = moment().format('DD-MM-YYYY')
      this.schedule.push(payload)
    },
    onCheckDate() {},
    deleteSchedule(data) {
      const id = get(data, 'id')
      if (id) {
        const index = this.schedule.findIndex((v) => v.id === id)
        if (index > -1) this.schedule.splice(index, 1)
      }
    },
    getConfigData() {
      return {
        schedule: this.schedule,
        scheduleType: this.scheduleType,
        endDate: this.endDateTime,
      }
    },
    handlerExistedData(val) {
      const type = get(val, 'scheduleType')
      if (type) {
        this.scheduleType = type
        const existedSchedule = get(val, 'schedule', [])
        if (existedSchedule && existedSchedule.length) {
          this.schedule = existedSchedule
        }
      }
    },
    redirectToClass() {
      window.open(`/class/${this.classData.id}`, '_blank')
    },
    redirectToGrade() {
      const titleContains = get(this.classData, 'grade.title', '')
      const codeContains = get(this.classData, 'grade.code', '')
      localStorage.setItem(
        'grade-query',
        JSON.stringify({ title_contains: titleContains, code_contains: codeContains })
      )
      window.open('/grades', '_blank')
    },
    updateFreeSchedules(newSchedules) {
      this.freeSchedules = newSchedules
      this.schedule = [...this.weeklySchedules, ...this.freeSchedules]
    },
    updateEndDateTime(newEndDateTime) {
      this.endDateTime = newEndDateTime
    },
  },
  watch: {
    classProp: {
      handler(val) {
        if (val && val.id) {
          this.reset()
          this.handlerExistedData(val)
          this.schedule = val.schedule || []
          this.classData = val
          this.beginningDate = get(val, 'beginningDate', null)
          this.endDateTime = get(val, 'endDateTime', null)
        }
      },
      immediate: true,
      deep: true,
    },
    schedule: {
      handler(val) {
        if (val) {
          this.weeklySchedules = val.filter((schedule) => schedule.type === 'weekly-schedule')
          this.freeSchedules = val.filter((schedule) => schedule.type === 'free-schedule')
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.timetable-wrapper {
  border: 1px solid #e6e4eb;
  margin: 24px;
  padding: 16px;
}
.bold-text {
  font-weight: 500;
  font-size: 16px;
}
</style>
